import { render, staticRenderFns } from "./rate-widget.vue?vue&type=template&id=d60fa7d8&scoped=true&"
import script from "./rate-widget.vue?vue&type=script&lang=js&"
export * from "./rate-widget.vue?vue&type=script&lang=js&"
import style0 from "./rate-widget.vue?vue&type=style&index=0&id=d60fa7d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60fa7d8",
  null
  
)

export default component.exports